import { type JSX } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./data.css";
import CloudConnectionProvider from "@via/context/cloud-connection-provider.tsx";
import { ArrowTurnDownLeftIcon } from "@heroicons/react/24/outline";
import { ROUTES } from "@via/utils/constants";

function Data(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <CloudConnectionProvider>
      <main className="via-content-wrapper">
        {location.pathname !== ROUTES.COLLECTIONS ? (
          <button
            onClick={() => navigate(ROUTES.COLLECTIONS)}
            className="flex items-center gap-2 mb-3 text-sm font-semibold text-gray-500 hover:text-gray-700">
            <ArrowTurnDownLeftIcon className="h-5 w-5" />
            Back
          </button>
        ) : null}

        <Outlet />
      </main>
    </CloudConnectionProvider>
  );
}

export default Data;
